import HistoryProvider from './HistoryProvider';

export default class HistoryService {
  constructor({ target }) {
    this.target = target;
  }

  get() {
    return HistoryProvider.getActivityHistory(this.target.id);
  }

  subscribe(callback, coursewareId) {
    return HistoryProvider.subscribeToActivityHistory(this.target.id, callback, coursewareId);
  }

  static build(args) {
    return new HistoryService(args);
  }
}
